import React, { useContext, useCallback } from 'react';
import { // eslint-disable-line import/no-extraneous-dependencies
  LongPressGestureHandler,
  State,
} from 'react-native-gesture-handler';
import { Platform } from 'react-native';

import { ScrollViewContext } from '../contexts/ScrollViewContext';
import { DraggableFlatListContext } from '../contexts/DraggableFlatListContext';
import { DragAndDropContext, STATUS } from '../contexts/DragAndDropContext';
import MultiSelectContext from '../../../contexts/MultiSelect';
import { logHandlerEvent } from '../utils';
import { DISTANCE_TO_DECIDE_RESPONDER } from '../constants';


const cancelWith = Platform.OS === 'ios' ? [
  State.END,
  State.CANCELLED,
  State.FAILED,
] : Platform.OS === 'web' ? [] : [
  State.END,
  State.FAILED,
];

const DraggableLongPressGestureHandler = ({
  children,
}) => {
  const {
          waitForLongPressMs, longPressGestureRef, scrollViewGestureRef, verticalPanGestureRef,
        } = useContext(DraggableFlatListContext),
        { isEnabled } = useContext(MultiSelectContext),
        { isUserScrolling, isScrolling } = useContext(ScrollViewContext),
        { reset, onLongPress, touchStatus } = useContext(DragAndDropContext);

  const onHandlerStateChange = useCallback(({ nativeEvent }) => {
    logHandlerEvent('LongPressGestureHandler', { nativeEvent });
    if (nativeEvent.state === State.ACTIVE) {
      onLongPress(nativeEvent);
    }

    if (touchStatus === STATUS.DRAGGED && cancelWith.includes(nativeEvent.state)) {
      reset();
    }
  }, [onLongPress, reset, touchStatus]);

  return (
    <LongPressGestureHandler
      ref={longPressGestureRef}
      enabled={!isEnabled && (((!isUserScrolling || Platform.OS === 'android') && !isScrolling) || touchStatus === STATUS.DRAGGED)}
      maxDist={DISTANCE_TO_DECIDE_RESPONDER}
      minDurationMs={waitForLongPressMs}
      simultaneousHandlers={[verticalPanGestureRef, scrollViewGestureRef]}
      onHandlerStateChange={onHandlerStateChange}
    >
      { children }
    </LongPressGestureHandler>
  );
};

export default DraggableLongPressGestureHandler;
